import { Box, Select } from '@material-ui/core';
import styled from 'styled-components';

export const FontSelectorWrapper = styled(Box)`
  min-width: 350px;
  padding-top: 20px;
`;

export const CustomSelect = styled(Select)`
  // Trocar cor da border
`;
